module.exports = __webpack_public_path__ + "img/more.bfbf786e.png";